/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import CloseIcon from '@mui/icons-material/Close';
import { IconButton, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { setIsObjectsPopupVisible } from "../../../../redux/ducks/User/slice";
import { renderLink } from "../../../pages/CoverageRequirements/ItemDetails/Tabs/CoverageRequirementsTab/RightPanelComponents/DrivingScenarioProperties";
import { DashboardRow } from "../../../pages/CoverageRequirements/ItemDetails/Tabs/ExecutionStatusTab/constants";
import ArgosButton from "../../Buttons/ArgosButton";
import ArgosFlexbox from "../../Containers/ArgosFlexbox";
import ArgosDialogHeader from "../ArgosDialogHeader";

const ObjectsColumnPopup = (props:any) => {
    const row = props?.row                    //pull in current row from Dashboard.tsx
    const dialogTitle = row?.original.name    //use dataset name as dialog title
    const dispatch = useDispatch()
    const onClickClose = () => {              //close popup function
        dispatch(setIsObjectsPopupVisible(false))   
    }

    //similar to renderPropertyCell function in Dashboard.tsx
    const properties = row?.original?.object as keyof DashboardRow
    if (properties !== undefined && Array.isArray(properties)) {
      const reducedProperties = properties.reduce((accumulator: any, current: any) => {
        if (!accumulator.find((item: any) => item.name === current.name)) {
            accumulator.push(current);
        }
        return accumulator
        }, [])
        return (<>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div>
                    <ArgosDialogHeader>
                        <ArgosFlexbox style={{justifyContent: 'space-between'}}>
                            <Typography sx={{ color: 'white', fontSize: 18, alignContent: 'center' }}>{dialogTitle} : Objects</Typography> 
                            <IconButton onClick={onClickClose} sx={{color: 'white', justifyContent: 'space-between'}}> 
                                <CloseIcon />
                            </IconButton>
                        </ArgosFlexbox>
                    </ArgosDialogHeader>
                </div>
                <ArgosFlexbox vertical style={{padding:'20px'}}>
                    {
                        reducedProperties?.map((property: any) => renderLink(
                        property.name, 
                        property.property_link
                        )) 
                    }
                </ArgosFlexbox>
            </div>
        </>)}
        else
            return(<>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div>
                        <ArgosDialogHeader>
                            <Typography sx={{ color: 'white', fontSize: 14 }}>{dialogTitle}</Typography>
                        </ArgosDialogHeader>
                    </div>
                </div>
                <div style={{marginTop: 10, display: 'flex', justifyContent: 'center', gap: 10, justifySelf: 'flex-end'}}>
                    <ArgosButton onClick={onClickClose}>CANCEL</ArgosButton>
                </div>
            </>)
}
export default ObjectsColumnPopup;